import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Banner from '../../assets/senior_banner.svg'
import BlueTick from '../../assets/blue_tick.svg'
import { pushToDataLayer, logEvent } from '../Analytics'

class Hero extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
    const {headerBackBlue, headerMobileBackBlue} = this.props.query;
            return(
                <Fragment>
                    <section className="cvd-banner">
                        <div className="custom-container">
                            <div className="bottom-content">
                                <h1 className="desktop">Albert stöttar alla barn i <br/> Sverige med gratis läxhjälp</h1>
                                <h1 className="for-mobile">Albert stöttar alla <br/> barn i Sverige med <br/> gratis läxhjälp</h1>
                            </div>
                        </div>
                        
                    </section>
                </Fragment>
            )
        
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    headerBackBlue: file(relativePath: {regex: "/junior-banner/"}) {
                        publicURL
                    }
                    headerMobileBackBlue: file(relativePath: {regex: "/junior-mobile-banner-wave/"}) {
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <Hero query={data} {...props}/>
        )}
    />
)